import XHR from '@/request/http'
const $h = new XHR()
/**
 * 模板相关
 * 
 * 
 */

// url
const url = {
    create:'/admin/v1/reflections/create', //发布教学反思
    get:'/admin/v1/reflections/get', //获取教学反思
}

export async function create(data)
{
    return $h.request(url.create,data,'POST')
}

export async function get(lessonId){
    return $h.request(url.get+`?lessonId=${lessonId}`,'GET')
}